import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateViewGuard } from '../guards/can-activate-view.guard';
import { RegisterTransportInvoiceComponent } from './additional/transport-invoice/register-transport-invoice/register-transport-invoice.component';
import { TransportInvoiceComponent } from './additional/transport-invoice/transport-invoice/transport-invoice.component';
import { ArticleGenericComponent } from './archive/article-generic/article-generic/article-generic.component';
import { RegisterArticleGenericComponent } from './archive/article-generic/register-article-generic/register-article-generic.component';
import { ArticleComponent } from './archive/article/article/article.component';
import { MaintenanceStrategyImportComponent } from './archive/article/maintenance-strategy-import/maintenance-strategy-import.component';
import { RegisterArticleComponent } from './archive/article/register-article/register-article.component';
import { ClientComponent } from './archive/client/client/client.component';
import { RegisterClientComponent } from './archive/client/register-client/register-client.component';
import { ConstructionSiteComponent } from './archive/construction-site/construction-site/construction-site.component';
import { RegisterConstructionSiteComponent } from './archive/construction-site/register-construction-site/register-construction-site.component';
import { CostCenterPriceComponent } from './archive/cost-center-price/cost-center-price/cost-center-price.component';
import { CostCenterComponent } from './archive/cost-center/cost-center/cost-center.component';
import { RegisterCostCenterComponent } from './archive/cost-center/register-cost-center/register-cost-center.component';
import { CurrencyExchangeComponent } from './archive/currency-exchange/currency-exchange/currency-exchange.component';
import { RegisterCurrencyExchangeComponent } from './archive/currency-exchange/register-currency-exchange/register-currency-exchange.component';
import { FamilyComponent } from './archive/family/family/family.component';
import { RegisterFamilyComponent } from './archive/family/register-family/register-family.component';
import { GroupComponent } from './archive/group/group/group.component';
import { RegisterGroupComponent } from './archive/group/register-group/register-group.component';
import { MechanicComponent } from './archive/mechanic/mechanic/mechanic.component';
import { RegisterMechanicComponent } from './archive/mechanic/register-mechanic/register-mechanic.component';
import { ImportPriceListAsComponent } from './archive/price-list-detail/import-price-list-as/import-price-list-as.component';
import { PriceListComponent } from './archive/price-list/price-list/price-list.component';
import { RegisterPriceListComponent } from './archive/price-list/register-price-list/register-price-list.component';
import { ProviderComponent } from './archive/provider/provider/provider.component';
import { RegisterProviderComponent } from './archive/provider/register-provider/register-provider.component';
import { RegisterSellerComponent } from './archive/seller/register-seller/register-seller.component';
import { SellerComponent } from './archive/seller/seller/seller.component';
import { RegisterStoreComponent } from './archive/store/register-store/register-store.component';
import { StoreComponent } from './archive/store/store/store.component';
import { RegisterSubgroupComponent } from './archive/subgroup/register-subgroup/register-subgroup.component';
import { SubgroupComponent } from './archive/subgroup/subgroup/subgroup.component';
import { RegisterTransporterComponent } from './archive/transporter/register-transporter/register-transporter.component';
import { TransporterComponent } from './archive/transporter/transporter/transporter.component';
import { RegisterUnitComponent } from './archive/unit/register-unit/register-unit.component';
import { UnitComponent } from './archive/unit/unit/unit.component';
import { RegisterVehicleComponent } from './archive/vehicle/register-vehicle/register-vehicle.component';
import { VehicleComponent } from './archive/vehicle/vehicle/vehicle.component';
import { RegisterZoneComponent } from './archive/zone/register-zone/register-zone.component';
import { ZoneComponent } from './archive/zone/zone/zone.component';
import { AuditComponent } from './audit/audit/audit.component';
import { TransactionsComponent } from './audit/transactions/transactions.component';
import { ProfileUserComponent } from './authentication/profile-user/profile-user/profile-user.component';
import { RegisterProfileUserComponent } from './authentication/profile-user/register-profile-user/register-profile-user.component';
import { RegisterUsersComponent } from './authentication/users/register-users/register-users.component';
import { UserComponent } from './authentication/users/user/user.component';
import { HomeComponent } from './components/home/home.component';
import { MainComponent } from './components/main/main.component';
import { FormatComponent } from './formats/format/format/format.component';
import { RegisterFormatComponent } from './formats/format/register-format/register-format.component';
import { CostAdjustmentComponent } from './inventory/cost-adjustment/cost-adjustment/cost-adjustment.component';
import { RegisterCostAdjustmentComponent } from './inventory/cost-adjustment/register-cost-adjustment/register-cost-adjustment.component';
import { InventoryBalancesImportComponent } from './inventory/inventory-balances-import/inventory-balances-import.component';
import { InventoryClassComponent } from './inventory/inventory-class/inventory-class/inventory-class.component';
import { InventoryEntryComponent } from './inventory/inventory-entry/inventory-entry/inventory-entry.component';
import { RegisterInventoryEntryComponent } from './inventory/inventory-entry/register-inventory-entry/register-inventory-entry.component';
import { InventoryOutputComponent } from './inventory/inventory-output/inventory-output/inventory-output.component';
import { RegisterInventoryOutputComponent } from './inventory/inventory-output/register-inventory-output/register-inventory-output.component';
import { InventoryPeriodComponent } from './inventory/inventory-period/inventory-period/inventory-period.component';
import { RegisterInventoryPeriodComponent } from './inventory/inventory-period/register-inventory-period/register-inventory-period.component';
import { BranchAverageCostComponent } from './inventory/inventory-report/branch-average-cost/branch-average-cost.component';
import { EntryShopComponent } from './inventory/inventory-report/entry-shop/entry-shop.component';
import { KardexArticleComponent } from './inventory/inventory-report/kardex-article/kardex-article.component';
import { OutputShopComponent } from './inventory/inventory-report/output-shop/output-shop.component';
import { StockMaxComponent } from './inventory/inventory-report/stock-max/stock-max.component';
import { StockMinComponent } from './inventory/inventory-report/stock-min/stock-min.component';
import { SummaryInventoryMovementComponent } from './inventory/inventory-report/summary-inventory-movement/summary-inventory-movement.component';
import { TypeQuantitiesComponent } from './inventory/inventory-report/type-quantities/type-quantities.component';
import { TypeSummaryValuesComponent } from './inventory/inventory-report/type-summary-values/type-summary-values.component';
import { TypeDetailedValuesComponent } from './inventory/inventory-report/type_detailed_values/type_detailed_values.component';
import { InventoryTransferComponent } from './inventory/inventory-transfer/inventory-transfer/inventory-transfer.component';
import { RegisterInventoryTransferComponent } from './inventory/inventory-transfer/register-inventory-transfer/register-inventory-transfer.component';
import { InventoryComponent } from './inventory/inventory/inventory/inventory.component';
import { RegisterInventoryComponent } from './inventory/inventory/register-inventory/register-inventory.component';
import { PhysicalInventoryComponent } from './inventory/physical-inventory/physical-inventory/physical-inventory.component';
import { RegisterSalesRemissionComponent } from './inventory/sales-remission/register-sales-remission/register-sales-remission.component';
import { SalesRemissionComponent } from './inventory/sales-remission/sales-remission/sales-remission.component';
import { RegisterStockMaxMinComponent } from './inventory/stock-max-min/register-stock-max-min/register-stock-max-min.component';
import { StockMaxMinComponent } from './inventory/stock-max-min/stock-max-min/stock-max-min.component';
import { TypeInventoryComponent } from './inventory/type-inventory/type-inventory/type-inventory.component';
import { AccountingInterfaceComponent } from './invoicing/accounting-interface/accounting-interface/accounting-interface.component';
import { RegisterAccountingInterfaceComponent } from './invoicing/accounting-interface/register-accounting-interface/register-accounting-interface.component';
import { AdvanceInvoiceComponent } from './invoicing/advance-invoice/advance-invoice/advance-invoice.component';
import { RegisterAdvanceInvoiceComponent } from './invoicing/advance-invoice/register-advance-invoice/register-advance-invoice.component';
import { ConceptInvoicingComponent } from './invoicing/concept-invoicing/concept-invoicing/concept-invoicing.component';
import { RegisterConceptInvoicingComponent } from './invoicing/concept-invoicing/register-concept-invoicing/register-concept-invoicing.component';
import { ElectronicInvoiceInterfaceComponent } from './invoicing/electronic-invoice-interface/electronic-invoice-interface/electronic-invoice-interface.component';
import { RegisterElectronicInvoiceInterfaceComponent } from './invoicing/electronic-invoice-interface/register-electronic-invoice-interface/register-electronic-invoice-interface.component';
import { InvoiceComponent } from './invoicing/invoice/invoice/invoice.component';
import { InvoicesImportComponent } from './invoicing/invoice/invoices-import/invoices-import.component';
import { RegisterInvoiceComponent } from './invoicing/invoice/register-invoice/register-invoice.component';
import { InvoicingCutoffComponent } from './invoicing/invoicing-cutoff/invoicing-cutoff/invoicing-cutoff.component';
import { RegisterInvoicingCutoffComponent } from './invoicing/invoicing-cutoff/register-invoicing-cutoff/register-invoicing-cutoff.component';
import { InvoicingModelComponent } from './invoicing/invoicing-model/invoicing-model/invoicing-model.component';
import { RegisterInvoicingModelComponent } from './invoicing/invoicing-model/register-invoicing-model/register-invoicing-model.component';
import { BalancesCostCenterComponent } from './invoicing/invoicing-report/balances-cost-center/balances-cost-center.component';
import { DailyReportVoucherComponent } from './invoicing/invoicing-report/daily-report-voucher/daily-report-voucher.component';
import { DiscountsLowerHundredPercentComponent } from './invoicing/invoicing-report/discounts-lower-hundred-percent/discounts-lower-hundred-percent.component';
import { DiscountsTopThirtyPercentComponent } from './invoicing/invoicing-report/discounts-top-thirty-percent/discounts-top-thirty-percent.component';
import { IncomeCostcenterEquipmentComponent } from './invoicing/invoicing-report/income-costcenter-equipment/income-costcenter-equipment.component';
import { IncomeReportComponent } from './invoicing/invoicing-report/income-report/income-report.component';
import { InvoicesByConceptComponent } from './invoicing/invoicing-report/invoices-by-concept/invoices-by-concept.component';
import { InvoicesGeneratedComponent } from './invoicing/invoicing-report/invoices-generated/invoices-generated.component';
import { InvoicingAddressReportComponent } from './invoicing/invoicing-report/invoicing-address-report/invoicing-address-report.component';
import { InvoicingBusinessTypeComponent } from './invoicing/invoicing-report/invoicing-business-type/invoicing-business-type.component';
import { InvoicingClientConstructionSiteComponent } from './invoicing/invoicing-report/invoicing-client-construction-site/invoicing-client-construction-site.component';
import { InvoicingClientCostCenterGroupComponent } from './invoicing/invoicing-report/invoicing-client-cost-center-group/invoicing-client-cost-center-group.component';
import { InvoicingClientComponent } from './invoicing/invoicing-report/invoicing-client/invoicing-client.component';
import { InvoicingConceptSellerComponent } from './invoicing/invoicing-report/invoicing-concept-seller/invoicing-concept-seller.component';
import { InvoicingConceptComponent } from './invoicing/invoicing-report/invoicing-concept/invoicing-concept.component';
import { InvoicingCostCenterComponent } from './invoicing/invoicing-report/invoicing-cost-center/invoicing-cost-center.component';
import { InvoicingFamilyComponent } from './invoicing/invoicing-report/invoicing-family/invoicing-family.component';
import { InvoicingKilogramsComponent } from './invoicing/invoicing-report/invoicing-kilograms/invoicing-kilograms.component';
import { InvoicingSellerConceptComponent } from './invoicing/invoicing-report/invoicing-seller-concept/invoicing-seller-concept.component';
import { InvoicingSellerKilogramsComponent } from './invoicing/invoicing-report/invoicing-seller-kilograms/invoicing-seller-kilograms.component';
import { ItemRevenueStoreComponent } from './invoicing/invoicing-report/item-revenue-store/item-revenue-store.component';
import { ItemRevenueComponent } from './invoicing/invoicing-report/item-revenue/item-revenue.component';
import { PendingInvoiceComponent } from './invoicing/invoicing-report/pending-invoice/pending-invoice.component';
import { PreInvoicingItemRevenueComponent } from './invoicing/invoicing-report/pre-invoicing-item-revenue/pre-invoicing-item-revenue.component';
import { TaxReportComponent } from './invoicing/invoicing-report/tax-report/tax-report.component';
import { TotalMonthComponent } from './invoicing/invoicing-report/total-month/total-month.component';
import { NoteComponent } from './invoicing/note/note/note.component';
import { NotesImportComponent } from './invoicing/note/notes-import/notes-import.component';
import { RegisterNoteComponent } from './invoicing/note/register-note/register-note.component';
import { PreInvoiceComponent } from './invoicing/pre-invoicing/pre-invoice/pre-invoice.component';
import { RegisterRequestNoteComponent } from './invoicing/request-note/register-request-note/register-request-note.component';
import { RequestNoteComponent } from './invoicing/request-note/request-note/request-note.component';
import { MaintenanceActivitiesComponent } from './maintenance/maintenance-activities/maintenance-activities/maintenance-activities.component';
import { RegisterMaintenanceActivitiesComponent } from './maintenance/maintenance-activities/register-maintenance-activities/register-maintenance-activities.component';
import { MaintenanceOrderImportComponent } from './maintenance/maintenance-order/maintenance-order-import/maintenance-order-import.component';
import { MaintenanceOrderComponent } from './maintenance/maintenance-order/maintenance-order/maintenance-order.component';
import { RegisterMaintenanceOrderComponent } from './maintenance/maintenance-order/register-maintenance-order/register-maintenance-order.component';
import { EquipmentLogbookReportComponent } from './maintenance/maintenance-report/equipment-logbook-report/equipment-logbook-report.component';
import { MaintenanceCostsForEquipmentComponent } from './maintenance/maintenance-report/maintenance-costs-for-equipment/maintenance-costs-for-equipment.component';
import { ProgrammingDaysComponent } from './maintenance/maintenance-report/programming-days/programming-days.component';
import { RepairHistoryComponent } from './maintenance/maintenance-report/repair-history/repair-history.component';
import { MaintenanceRoutineSupplyImportComponent } from './maintenance/maintenance-routine-supply/maintenance-routine-supply-import/maintenance-routine-supply-import.component';
import { MaintenanceRoutineImportComponent } from './maintenance/maintenance-routine/maintenance-routine-import/maintenance-routine-import.component';
import { MaintenanceRoutineComponent } from './maintenance/maintenance-routine/maintenance-routine/maintenance-routine.component';
import { RegisterMaintenanceRoutineComponent } from './maintenance/maintenance-routine/register-maintenance-routine/register-maintenance-routine.component';
import { MaintenanceSchedulingComponent } from './maintenance/maintenance-scheduling/maintenance-scheduling/maintenance-scheduling.component';
import { RegisterMaintenanceSchedulingComponent } from './maintenance/maintenance-scheduling/register-maintenance-scheduling/register-maintenance-scheduling.component';
import { MeterComponent } from './maintenance/meter/meter/meter.component';
import { RegisterMeterComponent } from './maintenance/meter/register-meter/register-meter.component';
import { RepairImportComponent } from './maintenance/repair/repair-import/repair-import.component';
import { StoreBalancesImportComponent } from './maintenance/store-balances-import/store-balances-import.component';
import { RegisterTransferStoreWorkshopComponent } from './maintenance/transfer-store-workshop/register-transfer-store-workshop/register-transfer-store-workshop.component';
import { TransferStoreWorkshopComponent } from './maintenance/transfer-store-workshop/transfer-store-workshop/transfer-store-workshop.component';
import { RegisterTransferWorkshopStoreComponent } from './maintenance/transfer-workshop-store/register-transfer-workshop-store/register-transfer-workshop-store.component';
import { TransferWorkshopStoreComponent } from './maintenance/transfer-workshop-store/transfer-workshop-store/transfer-workshop-store.component';
import { ListWorkshopEquipmentComponent } from './maintenance/workshop-equipment/list-workshop-equipment/list-workshop-equipment.component';
import { AccountingModelComponent } from './management/accounting-model/accounting-model/accounting-model.component';
import { BranchComponent } from './management/branch/branch/branch.component';
import { RegisterBranchComponent } from './management/branch/register-branch/register-branch.component';
import { BussinessDocumentsResolutionComponent } from './management/bussiness-documents-resolution/bussiness-documents-resolution/bussiness-documents-resolution.component';
import { RegisterBussinessDocumentsResolutionComponent } from './management/bussiness-documents-resolution/register-bussiness-documents-resolution/register-bussiness-documents-resolution.component';
import { BussinessDocumentsTypeComponent } from './management/bussiness-documents-type/bussiness-documents-type/bussiness-documents-type.component';
import { RegisterBussinessDocumentsTypeComponent } from './management/bussiness-documents-type/register-bussiness-documents-type/register-bussiness-documents-type.component';
import { CityComponent } from './management/city/city/city.component';
import { CompanyCityComponent } from './management/company-city/company-city/company-city.component';
import { CompanyComponent } from './management/company/company/company.component';
import { RegisterCompanyComponent } from './management/company/register-company/register-company.component';
import { ConceptComponent } from './management/concept/concept/concept.component';
import { RegisterConceptComponent } from './management/concept/register-concept/register-concept.component';
import { CurrencyComponent } from './management/currency/currency/currency.component';
import { DepartmentComponent } from './management/department/department/department.component';
import { EnterpriseComponent } from './management/enterprise/enterprise/enterprise.component';
import { RegisterEnterpriseComponent } from './management/enterprise/register-enterprise/register-enterprise.component';
import { FreightComponent } from './management/freight/freight/freight.component';
import { RegisterFreightComponent } from './management/freight/register-freight/register-freight.component';
import { IcaRateComponent } from './management/ica-rate/ica-rate/ica-rate.component';
import { RegisterIcaRateComponent } from './management/ica-rate/register-ica-rate/register-ica-rate.component';
import { RegisterSectorComponent } from './management/sector/register-sector/register-sector.component';
import { SectorComponent } from './management/sector/sector/sector.component';
import { TaxTypeComponent } from './management/tax-type/tax-type/tax-type.component';
import { RegisterTaxComponent } from './management/tax/register-tax/register-tax.component';
import { TaxComponent } from './management/tax/tax/tax.component';
import { TypeConceptComponent } from './management/type-concept/type-concept/type-concept.component';
import { RegisterWayToPayComponent } from './management/way-to-pay/register-way-to-pay/register-way-to-pay.component';
import { WayToPayComponent } from './management/way-to-pay/way-to-pay/way-to-pay.component';
import { ArticleTaskComponent } from './others/article-task/article-task/article-task.component';
import { RegisterArticleTaskComponent } from './others/article-task/register-article-task/register-article-task.component';
import { ChargeAccountComponent } from './others/charge-account/charge-account/charge-account.component';
import { RegisterChargeAccountComponent } from './others/charge-account/register-charge-account/register-charge-account.component';
import { RegisterUpdateCostCenterPriceComponent } from './others/update-cost-center-price/register-update-cost-center-price/register-update-cost-center-price.component';
import { CompositeArticleComponent } from './preliminaries/composite-article/composite-article/composite-article.component';
import { RegisterCompositeArticleComponent } from './preliminaries/composite-article/register-composite-article/register-composite-article.component';
import { ConsolidatedEquipmentAvailabilityComponent } from './preliminaries/consolidated-equipment-availability/consolidated-equipment-availability/consolidated-equipment-availability.component';
import { ConsolidatedReservationComponent } from './preliminaries/consolidated-reservation/consolidated-reservation/consolidated-reservation.component';
import { DevolutionProjectionComponent } from './preliminaries/devolution-projection/devolution-projection/devolution-projection.component';
import { RegisterDevolutionProjectionComponent } from './preliminaries/devolution-projection/register-devolution-projection/register-devolution-projection.component';
import { EquipmentAvailabilityComponent } from './preliminaries/equipment-availability/equipment-availability/equipment-availability.component';
import { ExecutedVisitComponent } from './preliminaries/executed-visit/executed-visit/executed-visit.component';
import { RegisterExecutedVisitComponent } from './preliminaries/executed-visit/register-executed-visit/register-executed-visit.component';
import { MasterSolutionComponent } from './preliminaries/master-solution/master-solution/master-solution.component';
import { RegisterMasterSolutionComponent } from './preliminaries/master-solution/register-master-solution/register-master-solution.component';
import { ImportOrdersComponent } from './preliminaries/order/import-orders/import-orders.component';
import { OrderComponent } from './preliminaries/order/order/order.component';
import { OrdersConsultationComponent } from './preliminaries/order/orders-consultation/orders-consultation.component';
import { RegisterOrderComponent } from './preliminaries/order/register-order/register-order.component';
import { PendingOrderComponent } from './preliminaries/preliminaries-report/pending-order/pending-order.component';
import { PurchaseProjectionComponent } from './preliminaries/purchase-projection/purchase-projection/purchase-projection.component';
import { RegisterQuotationDetailComponent } from './preliminaries/quotation-detail/register-quotation-detail/register-quotation-detail.component';
import { ImplementQuotationComponent } from './preliminaries/quotation/implement-quotation/implement-quotation.component';
import { ImportQuotationsComponent } from './preliminaries/quotation/import-quotations/import-quotations.component';
import { QuotationComponent } from './preliminaries/quotation/quotation/quotation.component';
import { RegisterQuotationComponent } from './preliminaries/quotation/register-quotation/register-quotation.component';
import { RegisterScheduledVisitComponent } from './preliminaries/scheduled-visit/register-scheduled-visit/register-scheduled-visit.component';
import { ScheduledVisitComponent } from './preliminaries/scheduled-visit/scheduled-visit/scheduled-visit.component';
import { DeactivateConstructionSiteComponent } from './rental/deactivate-construction-site/deactivate-construction-site/deactivate-construction-site.component';
import { DevolutionComponent } from './rental/devolution/devolution/devolution.component';
import { RegisterDevolutionComponent } from './rental/devolution/register-devolution/register-devolution.component';
import { RegisterOrderAdjustmentComponent } from './rental/order-adjustment/register-order-adjustment/register-order-adjustment.component';
import { RegisterRemissionComponent } from './rental/remission/register-remission/register-remission.component';
import { RemissionComponent } from './rental/remission/remission/remission.component';
import { ImportRentalBalanceComponent } from './rental/rental-balance/import-rental-balance/import-rental-balance.component';
import { RentalMovementImportComponent } from './rental/rental-balance/rental-movement-import/rental-movement-import.component';
import { RentalPeriodComponent } from './rental/rental-period/rental-period/rental-period.component';
import { BalancesClientCostcenterComponent } from './rental/rental-report/balances-client-costcenter/balances-client-costcenter.component';
import { BalancesShopComponent } from './rental/rental-report/balances-shop/balances-shop.component';
import { BalancesWorkshopComponent } from './rental/rental-report/balances-workshop/balances-workshop.component';
import { ClientDistributionComponent } from './rental/rental-report/client-distribution/client-distribution.component';
import { ConstructionWithoutEquipmentComponent } from './rental/rental-report/construction-without-equipment/construction-without-equipment.component';
import { CostCenterDiscountsComponent } from './rental/rental-report/cost-center-discounts/cost-center-discounts.component';
import { CostCenterDistributionComponent } from './rental/rental-report/cost-center-distribution/cost-center-distribution.component';
import { DaysConstructionSiteComponent } from './rental/rental-report/days-construction-site/days-construction-site.component';
import { HistoricalMovementCostCenterComponent } from './rental/rental-report/historical-movement-cost-center/historical-movement-cost-center.component';
import { HistoricalMovementShopComponent } from './rental/rental-report/historical-movement-shop/historical-movement-shop.component';
import { HistoricalMovementWorkshopComponent } from './rental/rental-report/historical-movement-workshop/historical-movement-workshop.component';
import { InvoicedReplacementComponent } from './rental/rental-report/invoiced-replacement/invoiced-replacement.component';
import { MovementsKilogramsComponent } from './rental/rental-report/movements-kilograms/movements-kilograms.component';
import { OccupancyPercentageComponent } from './rental/rental-report/occupancy-percentage/occupancy-percentage.component';
import { ReportReplacementComponent } from './rental/rental-report/report-replacement/report-replacement.component';
import { SummaryBalancesComponent } from './rental/rental-report/summary-balances/summary-balances.component';
import { TotalDistributionComponent } from './rental/rental-report/total-distribution/total-distribution.component';
import { TransportComponent } from './rental/rental-report/transport/transport.component';
import { RegisterServiceComponent } from './rental/service/register-service/register-service.component';
import { ServiceComponent } from './rental/service/service/service.component';
import { RegisterSuspensionComponent } from './rental/suspension/register-suspension/register-suspension.component';
import { SuspensionComponent } from './rental/suspension/suspension/suspension.component';
import { RegisterTransferConstructionSiteComponent } from './rental/transfer-construction-site/register-transfer-construction-site/register-transfer-construction-site.component';
import { TransferConstructionSiteComponent } from './rental/transfer-construction-site/transfer-construction-site/transfer-construction-site.component';
import { ConsolidatedPendingsOrdersComponent } from './shopping/consolidated-pendings-orders/consolidated-pendings-orders/consolidated-pendings-orders.component';
import { DocumentSupportImportComponent } from './shopping/document-support/document-support-import/document-support-import.component';
import { DocumentSupportComponent } from './shopping/document-support/document-support/document-support.component';
import { RegisterDocumentSupportComponent } from './shopping/document-support/register-document-support/register-document-support.component';
import { InternalOrderImportComponent } from './shopping/internal-order/internal-order-import/internal-order-import.component';
import { InternalOrderComponent } from './shopping/internal-order/internal-order/internal-order.component';
import { RegisterInternalOrderComponent } from './shopping/internal-order/register-internal-order/register-internal-order.component';
import { ProviderInvoiceComponent } from './shopping/provider-invoice/provider-invoice/provider-invoice.component';
import { RegisterProviderInvoiceComponent } from './shopping/provider-invoice/register-provider-invoice/register-provider-invoice.component';
import { ProviderNoteComponent } from './shopping/provider-note/provider-note/provider-note.component';
import { RegisterProviderNoteComponent } from './shopping/provider-note/register-provider-note/register-provider-note.component';
import { PurchaseOrderImportComponent } from './shopping/purchase-order/purchase-order-import/purchase-order-import.component';
import { PurchaseOrderComponent } from './shopping/purchase-order/purchase-order/purchase-order.component';
import { RegisterPurchaseOrderComponent } from './shopping/purchase-order/register-purchase-order/register-purchase-order.component';
import { StorePriceComponent } from './subrental/store-price/store-price/store-price.component';
import { RegisterSubrentalCutoffComponent } from './subrental/subrental-cutoff/register-subrental-cutoff/register-subrental-cutoff.component';
import { SubrentalCutoffComponent } from './subrental/subrental-cutoff/subrental-cutoff/subrental-cutoff.component';
import { RegisterSubrentalEntryComponent } from './subrental/subrental-entry/register-subrental-entry/register-subrental-entry.component';
import { SubrentalEntryComponent } from './subrental/subrental-entry/subrental-entry/subrental-entry.component';
import { RegisterSubrentalOutputComponent } from './subrental/subrental-output/register-subrental-output/register-subrental-output.component';
import { SubrentalOutputComponent } from './subrental/subrental-output/subrental-output/subrental-output.component';
import { ItemPreinvoicedValueComponent } from './subrental/subrental-report/item-preinvoiced-value/item-preinvoiced-value.component';
import { ItemUtilityComponent } from './subrental/subrental-report/item-utility/item-utility.component';
import { CloseConcurrenceComponent } from './utilities/concurrence/close-concurrence/close-concurrence.component';
import { LogsComponent } from './utilities/logs/logs.component';
import { SynchronizeInventoryMovementComponent } from './utilities/synchronize-siesa/synchronize-inventory-movement/synchronize-inventory-movement.component';
import { CashReceiptImportComponent } from './wallet/cash-receipt/cash-receipt-import/cash-receipt-import.component';
import { CashReceiptComponent } from './wallet/cash-receipt/cash-receipt/cash-receipt.component';
import { InvoiceCashReceiptRetentionImportComponent } from './wallet/cash-receipt/invoice-cash-receipt-retention-import/invoice-cash-receipt-retention-import.component';
import { RegisterCashReceiptComponent } from './wallet/cash-receipt/register-cash-receipt/register-cash-receipt.component';
import { WayToPayImportComponent } from './wallet/cash-receipt/way-to-pay-import/way-to-pay-import.component';
import { IncomeConceptComponent } from './wallet/income-concept/income-concept/income-concept.component';
import { RegisterIncomeConceptComponent } from './wallet/income-concept/register-income-concept/register-income-concept.component';
import { ProcessWalletBalanceComponent } from './wallet/wallet-balance/process-wallet-balance/process-wallet-balance.component';
import { RegisterWalletManagementComponent } from './wallet/wallet-management/register-wallet-management/register-wallet-management.component';
import { WalletManagementComponent } from './wallet/wallet-management/wallet-management/wallet-management.component';
import { CollectionBySellerComponent } from './wallet/wallet-report/collection-by-seller/collection-by-seller.component';
import { DetailedAccountStatementComponent } from './wallet/wallet-report/detailed-account-statement/detailed-account-statement.component';
import { GeneratedReceiptsComponent } from './wallet/wallet-report/generated-receipts/generated-receipts.component';
import { PaymentsByClientComponent } from './wallet/wallet-report/payments-by-client/payments-by-client.component';
import { SummaryAccountStatementComponent } from './wallet/wallet-report/summary-account-statement/summary-account-statement.component';
import { TotalIncomePerMonthComponent } from './wallet/wallet-report/total-income-per-month/total-income-per-month.component';
import { WalletBalanceComponent } from './wallet/wallet-report/wallet-balance/wallet-balance.component';
import { WalletComponent } from './wallet/wallet-report/wallet/wallet.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      //Route AccountingInterface
      {
        path: 'accounting-interface',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: AccountingInterfaceComponent,
          },
          {
            path: 'register',
            component: RegisterAccountingInterfaceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterAccountingInterfaceComponent,
          },
        ],
      },
      //Route Accounting Model
      {
        path: 'accounting-model',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: AccountingModelComponent,
          },
          {
            path: 'register',
            component: AccountingModelComponent,
          },
          {
            path: 'register/:id',
            component: AccountingModelComponent,
          },
        ],
      },
      //Route Advance Invoice
      {
        path: 'advance-invoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: AdvanceInvoiceComponent,
          },
          {
            path: 'register',
            component: RegisterAdvanceInvoiceComponent,
          }, {
            path: 'register/:id',
            component: RegisterAdvanceInvoiceComponent,
          }
        ]
      },
      //Route Article
      {
        path: 'article',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ArticleComponent,
          },
          {
            path: 'register',
            component: RegisterArticleComponent,
          },
          {
            path: 'register/:id',
            component: RegisterArticleComponent,
          },
        ],
      },
      //Route Article Task
      {
        path: 'article-task',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ArticleTaskComponent,
          },
          {
            path: 'register',
            component: RegisterArticleTaskComponent,
          },
          {
            path: 'register/:id',
            component: RegisterArticleTaskComponent,
          },
        ],
      },
      //Route Article Generic
      {
        path: 'article-generic',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ArticleGenericComponent,
          },
          {
            path: 'register',
            component: RegisterArticleGenericComponent,
          },
          {
            path: 'register/:id',
            component: RegisterArticleGenericComponent,
          },
        ],
      },
      //Route Audit
      {
        path: 'audit',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: AuditComponent,
          },
        ],
      },
      //Route Branch
      {
        path: 'branch',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BranchComponent,
          },
          {
            path: 'register',
            component: RegisterBranchComponent,
          },
          {
            path: 'register/:id',
            component: RegisterBranchComponent,
          },
        ],
      },
      //Route Bussiness Documents Resolution
      {
        path: 'bussiness-documents-resolution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BussinessDocumentsResolutionComponent,
          },
          {
            path: 'register',
            component: RegisterBussinessDocumentsResolutionComponent,
          },
          {
            path: 'register/:id',
            component: RegisterBussinessDocumentsResolutionComponent,
          },
        ],
      },
      //Route Bussiness Documents Type
      {
        path: 'bussiness-documents-type',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BussinessDocumentsTypeComponent,
          },
          {
            path: 'register',
            component: RegisterBussinessDocumentsTypeComponent,
          },
          {
            path: 'register/:id',
            component: RegisterBussinessDocumentsTypeComponent,
          },
        ],
      },
      // Route Cash Receipt
      {
        path: 'cash-receipt',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CashReceiptComponent
          },
          {
            path: 'register',
            component: RegisterCashReceiptComponent,
          }, {
            path: 'register/:id',
            component: RegisterCashReceiptComponent,
          }
        ]
      },
      // Route Cash Receipt Import
      {
        path: 'cash-receipt-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CashReceiptImportComponent
          }
        ]
      },
      // Route Invoice Cash Receipt Retention Import
      {
        path: 'invoice-cash-receipt-retention-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoiceCashReceiptRetentionImportComponent
          }
        ]
      },
      // Route Way To Pay Import
      {
        path: 'way-to-pay-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: WayToPayImportComponent
          }
        ]
      },
      // Route Cash Receipt Charge Account
      {
        path: 'cash-receipt-charge-account',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CashReceiptComponent
          },
          {
            path: 'register',
            component: RegisterCashReceiptComponent,
          }, {
            path: 'register/:id',
            component: RegisterCashReceiptComponent,
          }
        ]
      },
      //Route Charge Account
      {
        path: 'charge-account',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ChargeAccountComponent,
          },
          {
            path: 'register',
            component: RegisterChargeAccountComponent,
          },
          {
            path: 'register/:id',
            component: RegisterChargeAccountComponent,
          },
        ],
      },
      //Route Update CostCenter Price
      {
        path: 'update-cost-center-price',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            redirectTo: 'register',
            pathMatch: 'full'
          },
          {
            path: 'register',
            component: RegisterUpdateCostCenterPriceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterUpdateCostCenterPriceComponent,
          },
        ],
      },
      //Route City
      {
        path: 'city',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CityComponent,
          }
        ],
      },
      //Route Client
      {
        path: 'client',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ClientComponent,
          },
          {
            path: 'register',
            component: RegisterClientComponent,
          },
          {
            path: 'register/:id',
            component: RegisterClientComponent,
          },
        ],
      },
      //Route Composite Article
      {
        path: 'composite-article',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CompositeArticleComponent,
          },
          {
            path: 'register',
            component: RegisterCompositeArticleComponent,
          },
          {
            path: 'register/:id',
            component: RegisterCompositeArticleComponent,
          },
        ],
      },
      //Route Company
      {
        path: 'company',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CompanyComponent,
          },
          {
            path: 'register',
            component: RegisterCompanyComponent,
          },
          {
            path: 'register/:id',
            component: RegisterCompanyComponent,
          },
        ],
      },
      //Route Company-city
      {
        path: 'company-city',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CompanyCityComponent,
          }
        ],
      },
      //Route Concept
      {
        path: 'concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConceptComponent,
          },
          {
            path: 'register',
            component: RegisterConceptComponent,
          },
          {
            path: 'register/:id',
            component: RegisterConceptComponent,
          },
        ],
      },
      //Route Concept Invoicing
      {
        path: 'concept-invoicing',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConceptInvoicingComponent,
          },
          {
            path: 'register',
            component: RegisterConceptInvoicingComponent,
          },
          {
            path: 'register/:id',
            component: RegisterConceptInvoicingComponent,
          },
        ],
      },
      //Route Concept Invoicing
      {
        path: 'purchase-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConceptInvoicingComponent,
          },
          {
            path: 'register',
            component: RegisterConceptInvoicingComponent,
          },
          {
            path: 'register/:id',
            component: RegisterConceptInvoicingComponent,
          },
        ],
      },
      //Route Consolidated Pendings Orders
      {
        path: 'consolidated-pendings-orders',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConsolidatedPendingsOrdersComponent,
          }
        ],
      },
      {
        path: 'construction-site',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConstructionSiteComponent,
          },
          {
            path: 'register',
            component: RegisterConstructionSiteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterConstructionSiteComponent,
          },
        ],
      },
      //Route Cost Adjustment
      {
        path: 'cost-adjustment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CostAdjustmentComponent,
          },
          {
            path: 'register',
            component: RegisterCostAdjustmentComponent,
          },
          {
            path: 'register/:id',
            component: RegisterCostAdjustmentComponent,
          },
        ],
      },
      //Route Cost Center
      {
        path: 'cost-center',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CostCenterComponent,
          },
          {
            path: 'register',
            component: RegisterCostCenterComponent,
          },
          {
            path: 'register/:id',
            component: RegisterCostCenterComponent,
          },
        ],
      },
      //Route Cost Center Price
      {
        path: 'cost-center-price',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CostCenterPriceComponent,
          },
        ],
      },
      //Route Department
      {
        path: 'department',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DepartmentComponent,
          }
        ],
      },
      //Route Devolution
      {
        path: 'devolution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DevolutionComponent
          },
          {
            path: 'register',
            component: RegisterDevolutionComponent
          },
          {
            path: 'register/:id',
            component: RegisterDevolutionComponent
          }
        ]
      },
      //Route DevolutionProjection
      {
        path: 'devolution-projection',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DevolutionProjectionComponent
          },
          {
            path: 'register',
            component: RegisterDevolutionProjectionComponent
          },
          {
            path: 'register/:id',
            component: RegisterDevolutionProjectionComponent
          }
        ]
      },
      // Route Document Support Import
      {
        path: 'document-support-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DocumentSupportImportComponent
          }
        ]
      },
      //Route DocumentSupport
      {
        path: 'document-support',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DocumentSupportComponent,
          },
          {
            path: 'register',
            component: RegisterDocumentSupportComponent,
          },
          {
            path: 'register/:id',
            component: RegisterDocumentSupportComponent,
          },
        ],
      },
      //Route ProviderInvoice
      {
        path: 'provider-invoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProviderInvoiceComponent,
          },
          {
            path: 'register',
            component: RegisterProviderInvoiceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterProviderInvoiceComponent,
          },
        ],
      },
      //Route ProviderNote
      {
        path: 'provider-note',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProviderNoteComponent,
          },
          {
            path: 'register',
            component: RegisterProviderNoteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterProviderNoteComponent,
          },
        ],
      },
      //Route ElectronicInvoiceInterface
      {
        path: 'electronic-invoice-interface',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ElectronicInvoiceInterfaceComponent,
          },
          {
            path: 'register',
            component: RegisterElectronicInvoiceInterfaceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterElectronicInvoiceInterfaceComponent,
          },
        ],
      },
      //Route Enterprise
      {
        path: 'enterprise',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: EnterpriseComponent,
          },
          {
            path: 'register',
            component: RegisterEnterpriseComponent,
          },
          {
            path: 'register/:id',
            component: RegisterEnterpriseComponent,
          },
        ],
      },
      //Route Family
      {
        path: 'family',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: FamilyComponent,
          },
          {
            path: 'register',
            component: RegisterFamilyComponent,
          },
          {
            path: 'register/:id',
            component: RegisterFamilyComponent,
          },
        ],
      },
      //Route Format
      {
        path: 'format',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: FormatComponent,
          },
          {
            path: ':id',
            component: FormatComponent,
          },
          {
            path: 'register',
            component: RegisterFormatComponent,
          },
          {
            path: 'register/:id',
            component: RegisterFormatComponent,
          },
        ],
      },
      //Route Freight
      {
        path: 'freight',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: FreightComponent,
          },
          {
            path: 'register',
            component: RegisterFreightComponent,
          },
          {
            path: 'register/:id',
            component: RegisterFreightComponent,
          },
        ],
      },
      //Route Group
      {
        path: 'group',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: GroupComponent,
          },
          {
            path: 'register',
            component: RegisterGroupComponent,
          },
          {
            path: 'register/:id',
            component: RegisterGroupComponent,
          },
        ],
      },
      //Route Ica Rate
      {
        path: 'ica-rate',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: IcaRateComponent,
          },
          {
            path: 'register',
            component: RegisterIcaRateComponent,
          },
          {
            path: 'register/:id',
            component: RegisterIcaRateComponent,
          },
        ],
      },
      //Route Income Concept
      {
        path: 'income-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: IncomeConceptComponent,
          },
          {
            path: 'register',
            component: RegisterIncomeConceptComponent,
          },
          {
            path: 'register/:id',
            component: RegisterIncomeConceptComponent,
          },
        ],
      },
      //Route Currency
      {
        path: 'currency',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CurrencyComponent,
          }
        ],
      },
      //Route Currency Exchange
      {
        path: 'currency-exchange',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CurrencyExchangeComponent,
          },
          {
            path: 'register',
            component: RegisterCurrencyExchangeComponent,
          },
          {
            path: 'register/:id',
            component: RegisterCurrencyExchangeComponent,
          },
        ],
      },
      //Route Inventory
      {
        path: 'inventory',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryComponent,
          },
          {
            path: 'register',
            component: RegisterInventoryComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInventoryComponent,
          },
        ],
      },
      //Route Inventory Balances Import
      {
        path: 'inventory-balances-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryBalancesImportComponent,
          },
        ],
      },
      //Route Inventory Class
      {
        path: 'inventory-class',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryClassComponent,
          }
        ],
      },
      //Route Inventory Entry
      {
        path: 'inventory-entry',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryEntryComponent,
          },
          {
            path: 'register',
            component: RegisterInventoryEntryComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInventoryEntryComponent,
          },
        ],
      },
      //Route Inventory Output
      {
        path: 'inventory-output',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryOutputComponent
          },
          {
            path: 'register',
            component: RegisterInventoryOutputComponent
          },
          {
            path: 'register/:id',
            component: RegisterInventoryOutputComponent
          }
        ]
      },
      //Route Inventory Period
      {
        path: 'inventory-period',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryPeriodComponent,
          },
          {
            path: 'inventory-period-register',
            component: RegisterInventoryPeriodComponent,
          },
        ],
      },
      /////Routes Inventory Report----------------------
      //Route Branch Average Cost
      {
        path: 'branch-average-cost',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BranchAverageCostComponent,
          },
        ],
      },
      //Route Summary Inventory Movement
      {
        path: 'summary-inventory-movement',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SummaryInventoryMovementComponent,
          },
        ],
      },
      //Route Entry Shop
      {
        path: 'entry-shop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: EntryShopComponent,
          },
        ],
      },
      //Route Kardex Article
      {
        path: 'kardex-article',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: KardexArticleComponent,
          },
        ],
      },
      //Route Output Shop
      {
        path: 'output-shop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: OutputShopComponent,
          },
        ],
      },
      //Route Type Quantities
      {
        path: 'type-quantities',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TypeQuantitiesComponent,
          },
        ],
      },
      //Route Type Detail Values
      {
        path: 'type-detailed-values',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TypeDetailedValuesComponent,
          },
        ],
      },
      //Route Type Summary Values
      {
        path: 'type-summary-values',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TypeSummaryValuesComponent,
          },
        ],
      },
      //Route Stock Max
      {
        path: 'stock-max-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StockMaxComponent,
          },
        ],
      },
      //Route Stock Min
      {
        path: 'stock-min-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StockMinComponent,
          },
        ],
      },
      /////Routes Inventory Report ^^^^^^^^
      //Route Inventory Transfer
      {
        path: 'inventory-transfer',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InventoryTransferComponent,
          },
          {
            path: 'register',
            component: RegisterInventoryTransferComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInventoryTransferComponent,
          },
        ],
      },
      //Route Internal Order
      {
        path: 'internal-order',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InternalOrderComponent,
          },
          {
            path: 'register',
            component: RegisterInternalOrderComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInternalOrderComponent,
          },
        ],
      },
      //Route Interal Order Import
      {
        path: 'internal-order-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InternalOrderImportComponent,
          },
        ],
      },
      //Route Physical Inventory
      {
        path: 'physical-inventory',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PhysicalInventoryComponent,
          },
          {
            path: 'register',
            component: PhysicalInventoryComponent,
          },
          {
            path: 'register/:id',
            component: PhysicalInventoryComponent,
          },
        ],
      },

      //Route Invoice
      {
        path: 'invoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoiceComponent,
          },
          {
            path: 'register',
            component: RegisterInvoiceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInvoiceComponent,
          },
        ],
      },
      //Route PreInvoice
      {
        path: 'preinvoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PreInvoiceComponent,
          },
        ],
      },
      // Route Invoices Import
      {
        path: 'invoices-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicesImportComponent,
          },
        ],
      },
      // Route Note concepts Import
      {
        path: 'notes-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: NotesImportComponent,
          },
        ],
      },
      //Route Invoicing Cut Off
      {
        path: 'invoicing-cutoff',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingCutoffComponent,
          },
          {
            path: 'register',
            component: RegisterInvoicingCutoffComponent,
          },
          {
            path: 'register/:id',
            component: RegisterInvoicingCutoffComponent,
          },
        ],
      },
      //Route Invoicing Model
      {
        path: 'invoicing-model',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingModelComponent
          },
          {
            path: 'register',
            component: RegisterInvoicingModelComponent
          },
          {
            path: 'register/:id',
            component: RegisterInvoicingModelComponent
          }
        ]
      },
      //Route Purchase Model
      {
        path: 'purchase-model',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingModelComponent
          },
          {
            path: 'register',
            component: RegisterInvoicingModelComponent
          },
          {
            path: 'register/:id',
            component: RegisterInvoicingModelComponent
          }
        ]
      },
      /////Routes Invoicing Report ------------
      //Route Invoices By Concepts
      {
        path: 'invoices-by-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicesByConceptComponent,
          },
        ],
      },
      // Route Invoices Generated
      {
        path: 'invoices-generated',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicesGeneratedComponent,
          },
        ],
      },
      // Route Invoicing Client
      {
        path: 'invoicing-client',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingClientComponent,
          },
        ],
      },
      // Route Invoicing Client ConstructionSite CostCenter
      {
        path: 'invoicing-client-construction-site-cost-center',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingClientConstructionSiteComponent,
          },
        ],
      },
      // Route Invoicing Client CostCenter Group
      {
        path: 'invoicing-client-cost-center-group',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingClientCostCenterGroupComponent,
          },
        ],
      },
      // Route Discounts Top Thirty Percent
      {
        path: 'daily-report-voucher',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DailyReportVoucherComponent,
          },
        ],
      },
      // Route Discounts Top Thirty Percent
      {
        path: 'discounts-top-thirty-percent',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DiscountsTopThirtyPercentComponent,
          },
        ],
      },
      // Route Discounts Lower Hundred Percent
      {
        path: 'discounts-lower-hundred-percent',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DiscountsLowerHundredPercentComponent,
          },
        ],
      },
      // Route Income CostCenter Equipment
      {
        path: 'income-costcenter-equipment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: IncomeCostcenterEquipmentComponent,
          },
        ],
      },
      // Route Income Report
      {
        path: 'invoicing-report-income-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: IncomeReportComponent,
          },
        ],
      },
      // Route Invoicing Concept
      {
        path: 'invoicing-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingConceptComponent,
          },
        ],
      },
      // Route Invoicing Seller Concept
      {
        path: 'invoicing-seller-kilograms',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingSellerKilogramsComponent,
          },
        ],
      },
      // Route Invoicing Seller Concept
      {
        path: 'invoicing-seller-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingSellerConceptComponent,
          },
        ],
      },
      // Route Invoicing Concept Seller
      {
        path: 'invoicing-concept-seller',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingConceptSellerComponent,
          },
        ],
      },
      // Route Invoicing CostCenter
      {
        path: 'invoicing-cost-center',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingCostCenterComponent,
          },
        ],
      },
      // Route Invoicing Family
      {
        path: 'invoicing-family',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingFamilyComponent,
          },
        ],
      },
      // Route Item Revenue
      {
        path: 'item-revenue',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ItemRevenueComponent,
          },
        ],
      },
      // Route Pre-Invoicing Item Revenue
      {
        path: 'pre-invoicing-item-revenue',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PreInvoicingItemRevenueComponent,
          },
        ],
      },
      // Route Tax Report
      {
        path: 'tax-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TaxReportComponent,
          },
        ],
      },
      // Route Balances Cost Center
      {
        path: 'balances-cost-center',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BalancesCostCenterComponent,
          },
        ],
      },
      //Route Stock Max Min
      {
        path: 'stock-max-min',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StockMaxMinComponent,
          },
          {
            path: 'register',
            component: RegisterStockMaxMinComponent,
          },
          {
            path: 'register/:id',
            component: RegisterStockMaxMinComponent,
          }
        ],
      },
      //Route Item Revenue Store
      {
        path: 'item-revenue-store',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ItemRevenueStoreComponent,
          },
        ],
      },
      // Route Pending Invoice
      {
        path: 'pending-invoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PendingInvoiceComponent,
          },
        ],
      },
      // Route invoicing kilograms
      {
        path: 'invoicing-kilograms',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingKilogramsComponent,
          },
        ],
      },
      // Route invoicing kilograms
      {
        path: 'invoicing-kilograms',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingKilogramsComponent,
          },
        ],
      },
      // Route Address Report
      {
        path: 'invoicing-address-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingAddressReportComponent,
          },
        ],
      },
      // Route Total Month
      {
        path: 'total-month',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TotalMonthComponent,
          },
        ],
      },
      // Route Invoicing Seller Concept
      {
        path: 'invoicing-business-type',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicingBusinessTypeComponent,
          },
        ],
      },
      /////Routes Invoicing Report ^^^^^^^^
      //Route Main
      {
        path: 'main',
        children: [
          {
            path: '',
            component: MainComponent,
          },
        ],
      },
      //Route Maintenance
      {
        path: 'maintenance-order',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceOrderComponent,
          },
          {
            path: 'register',
            component: RegisterMaintenanceOrderComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMaintenanceOrderComponent,
          },
        ],
      },

      // Route Maintenance Order Import
      {
        path: 'maintenance-order-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceOrderImportComponent
          }
        ]
      },
      //Route Maintenance Activities
      {
        path: 'maintenance-routine',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceRoutineComponent,
          },
          {
            path: 'register',
            component: RegisterMaintenanceRoutineComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMaintenanceRoutineComponent,
          },
        ],
      },
      //Route Maintenance Routine Import
      {
        path: 'maintenance-routine-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceRoutineImportComponent,
          },
        ],
      },
      {
        path: 'maintenance-activities',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceActivitiesComponent,
          },
          {
            path: 'register',
            component: RegisterMaintenanceActivitiesComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMaintenanceActivitiesComponent,
          },
        ],
      },
      //Route Store Balances Import
      {
        path: 'store-balances-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StoreBalancesImportComponent,
          },
        ],
      },
      //Route Maintenance Scheduling
      {
        path: 'maintenance-scheduling',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceSchedulingComponent,
          },
          {
            path: 'register',
            component: RegisterMaintenanceSchedulingComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMaintenanceSchedulingComponent,
          },
        ],
      },
      //Route Maintenance Strategy Import
      {
        path: 'maintenance-strategy-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceStrategyImportComponent,
          },
        ],
      },
      //Route Maintenance Routine Supply Import
      {
        path: 'maintenance-routine-supply-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceRoutineSupplyImportComponent,
          },
        ],
      },
      {
        path: 'transfer-store-workshop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransferStoreWorkshopComponent,
          },
          {
            path: 'register',
            component: RegisterTransferStoreWorkshopComponent,
          },
          {
            path: 'register/:id',
            component: RegisterTransferStoreWorkshopComponent,
          },
        ],
      },
      {
        path: 'transfer-workshop-store',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransferWorkshopStoreComponent,
          },
          {
            path: 'register',
            component: RegisterTransferWorkshopStoreComponent,
          },
          {
            path: 'register/:id',
            component: RegisterTransferWorkshopStoreComponent,
          },
        ],
      },
      {
        path: 'workshop-equipment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ListWorkshopEquipmentComponent,
          },
        ],
      },
      //Route Equipment Availability
      {
        path: 'equipment-availability',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: EquipmentAvailabilityComponent,
          },
        ],
      },
      //Route Consolidated Equipment Availability
      {
        path: 'consolidated-equipment-availability',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConsolidatedEquipmentAvailabilityComponent,
          },
        ],
      },
      //Route Consolidated Reservation
      {
        path: 'consolidated-reservation',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConsolidatedReservationComponent,
          },
        ],
      },
      //Route Mechanic
      {
        path: 'mechanic',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MechanicComponent,
          },
          {
            path: 'register',
            component: RegisterMechanicComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMechanicComponent,
          },
        ],
      },
      //Route Meter
      {
        path: 'meter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MeterComponent,
          },
          {
            path: 'register',
            component: RegisterMeterComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMeterComponent,
          },
        ],
      },
      //Route Note
      {
        path: 'note',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: NoteComponent,
          },
          {
            path: 'register',
            component: RegisterNoteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterNoteComponent,
          },
        ],
      },
      //Route Request Note
      {
        path: 'request-note',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RequestNoteComponent,
          },
          {
            path: 'register',
            component: RegisterRequestNoteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterRequestNoteComponent,
          },
        ],
      },
      // Route Note Document Support
      {
        path: 'note-document-support',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: NoteComponent,
          },
          {
            path: 'register',
            component: RegisterNoteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterNoteComponent,
          },
        ],
      },
      //Route Order
      {
        path: 'order',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: OrderComponent,
          },
          {
            path: 'register',
            component: RegisterOrderComponent,
          },
          {
            path: 'register/:id',
            component: RegisterOrderComponent,
          },
        ],
      },
      //Route Orders Consultation
      {
        path: 'orders-consultation',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: OrdersConsultationComponent,
          },
        ],
      },
      //Route Import Pending Orders
      {
        path: 'import-orders',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ImportOrdersComponent,
          },
        ],
      },
      //Route Import Quotation
      {
        path: 'import-quotation',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ImportQuotationsComponent,
          },
        ],
      },
      //Route Order-Adjustment
      {
        path: 'order-adjustment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            redirectTo: 'register',
            pathMatch: 'full'
          },
          {
            path: 'register',
            component: RegisterOrderAdjustmentComponent,
          },
          {
            path: 'register/:id',
            component: RegisterOrderAdjustmentComponent,
          },
        ],
      },
      //Route Price List
      {
        path: 'price-list',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PriceListComponent
          },
          {
            path: 'register',
            component: RegisterPriceListComponent,
          }, {
            path: 'register/:id',
            component: RegisterPriceListComponent,
          }
        ]
      },
      //Route Price List Import As
      {
        path: 'price-list-as-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ImportPriceListAsComponent,
          },
        ],
      },
      //Route Profile User
      {
        path: 'profile-user',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProfileUserComponent,
          },
          {
            path: 'register',
            component: RegisterProfileUserComponent,
          },
          {
            path: 'register/:id',
            component: RegisterProfileUserComponent,
          },
        ],
      },
      //Route Provider
      {
        path: 'provider',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProviderComponent,
          },
          {
            path: 'register',
            component: RegisterProviderComponent,
          },
          {
            path: 'register/:id',
            component: RegisterProviderComponent,
          },
        ],
      },
      //Route Purchase Order
      {
        path: 'purchase-order',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PurchaseOrderComponent,
          },
          {
            path: 'register',
            component: RegisterPurchaseOrderComponent,
          },
          {
            path: 'register/:id',
            component: RegisterPurchaseOrderComponent,
          },
        ],
      },
      //Route Purchase Order Import
      {
        path: 'purchase-order-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PurchaseOrderImportComponent,
          },
        ],
      },
      //Route Purchase Projection
      {
        path: 'purchase-projection',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PurchaseProjectionComponent,
          },
        ],
      },
      //Route Remission
      {
        path: 'remission',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RemissionComponent
          },
          {
            path: 'register',
            component: RegisterRemissionComponent,
          }, {
            path: 'register/:id',
            component: RegisterRemissionComponent,
          }
        ]
      },
      //Route Transfer Construction Site
      {
        path: 'transfer-construction-site',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransferConstructionSiteComponent,
          },
          {
            path: 'register',
            component: RegisterTransferConstructionSiteComponent,
          },
          {
            path: 'register/:id',
            component: RegisterTransferConstructionSiteComponent,
          },
        ],
      },
      //Route Deactivate ConstructionSites
      {
        path: 'deactivate-construction-site',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DeactivateConstructionSiteComponent,
          }
        ],
      },
      //Route Rental Balance
      {
        path: 'balances-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ImportRentalBalanceComponent,
          },
        ],
      },
      //Route Rental Movement Import
      {
        path: 'rental-movement-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RentalMovementImportComponent,
          },
        ],
      },
      //Route Rental Period
      {
        path: 'rental-period',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RentalPeriodComponent,
          },
        ],
      },
      /////Routes Preliminaries Report -------------------
      // Route Balances Client Costcenter
      {
        path: 'preliminaries-balances-client-costcenter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BalancesClientCostcenterComponent,
          },
        ],
      },
      // Route Historical Movement CostCenter
      {
        path: 'preliminaries-historical-movement-costcenter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: HistoricalMovementCostCenterComponent,
          },
        ],
      },
      // Route Historical Pending Order
      {
        path: 'preliminaries-pending-order',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PendingOrderComponent,
          },
        ],
      },
      /////Routes Maintenance Report -------------------
      // Route Programming days
      {
        path: 'programming-days',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProgrammingDaysComponent,
          },
        ],
      },
      // Route Maintenance Costs for Equipment
      {
        path: 'maintenance-costs-for-equipment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MaintenanceCostsForEquipmentComponent,
          },
        ],
      },
      // Route Simple Equipment Logbook
      {
        path: 'equipment-logbook-report',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: EquipmentLogbookReportComponent,
          },
        ],
      },
      // Route Repair History
      {
        path: 'repair-history',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RepairHistoryComponent,
          },
        ],
      },
      // Route Repair Import
      {
        path: 'repairs-import',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: RepairImportComponent,
          },
        ],
      },
      /////Routes Rental Report -------------------
      // Route Balances Client Costcenter
      {
        path: 'balances-client-costcenter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BalancesClientCostcenterComponent,
          },
        ],
      },
      // Route Balances Shop
      {
        path: 'balances-shop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BalancesShopComponent,
          },
        ],
      },
      // Route Balances Workshop
      {
        path: 'balances-workshop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: BalancesWorkshopComponent,
          },
        ],
      },
      // Route Client Distribution
      {
        path: 'client-distribution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ClientDistributionComponent,
          },
        ],
      },
      // Route Construction Without Equipment
      {
        path: 'construction-without-equipment',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ConstructionWithoutEquipmentComponent,
          },
        ],
      },
      // Route Cost Center Distribution
      {
        path: 'cost-center-distribution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CostCenterDistributionComponent,
          },
        ],
      },
      // Route Historical Movement CostCenter
      {
        path: 'historical-movement-costcenter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: HistoricalMovementCostCenterComponent,
          },
        ],
      },

      // Route Days Construction Site
      {
        path: 'days-constructionsite',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DaysConstructionSiteComponent,
          },
        ],
      },

      // Route Movements Kilograms
      {
        path: 'movements-kilograms',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MovementsKilogramsComponent,
          },
        ],
      },
      //Route Historical Movement Shop
      {
        path: 'historical-movement-shop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: HistoricalMovementShopComponent,
          },
        ],
      },
      //Route Cost Center Discounts
      {
        path: 'cost-center-discounts',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CostCenterDiscountsComponent,
          },
        ],
      },
      //Route Historical Movement Shop
      {
        path: 'historical-movement-workshop',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: HistoricalMovementWorkshopComponent,
          },
        ],
      },
      // Route Invoiced Replacement
      {
        path: 'invoiced-replacement',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: InvoicedReplacementComponent,
          },
        ],
      },
      {
        path: 'quotation',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: QuotationComponent,
          },
          {
            path: 'register',
            component: RegisterQuotationComponent,
          },
          {
            path: 'register/:id',
            component: RegisterQuotationComponent,
          },
          {
            path: 'register/:id/solution',
            component: RegisterQuotationDetailComponent,
          },
          {
            path: 'register/:id/solution/:solutionId',
            component: RegisterQuotationDetailComponent,
          }
        ],
      },
      {
        path: 'implement-quotation',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ImplementQuotationComponent,
          },
        ],
      },
      // Route Report Occupancy Percentage
      {
        path: 'occupancy-percentage',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: OccupancyPercentageComponent,
          },
        ],
      },
      // Route Report Replacement
      {
        path: 'report-replacement',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ReportReplacementComponent,
          },
        ],
      },
      // Route Summary Balances
      {
        path: 'summary-balances',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SummaryBalancesComponent,
          },
        ],
      },
      //Route Total Distribution
      {
        path: 'total-distribution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TotalDistributionComponent,
          },
        ],
      },
      // Route Transport
      {
        path: 'transport',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransportComponent,
          },
        ],
      },
      /////Routes Rental Report ^^^^^^^^
      //Route Sales Remission
      {
        path: 'sales-remission',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SalesRemissionComponent
          },
          {
            path: 'register',
            component: RegisterSalesRemissionComponent,
          }, {
            path: 'register/:id',
            component: RegisterSalesRemissionComponent,
          }
        ]
      },
      //Route Executed Visit
      {
        path: 'executed-visit',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ExecutedVisitComponent
          },
          {
            path: 'register',
            component: RegisterExecutedVisitComponent,
          },
          {
            path: 'register/:id',
            component: RegisterExecutedVisitComponent,
          }
        ]
      },
      //Route Scheduled Visit
      {
        path: 'scheduled-visit',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ScheduledVisitComponent
          },
          {
            path: 'register',
            component: RegisterScheduledVisitComponent,
          },
          {
            path: 'register/:id',
            component: RegisterScheduledVisitComponent,
          }
        ]
      },
      //Route Sector
      {
        path: 'sector',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SectorComponent
          },
          {
            path: 'register',
            component: RegisterSectorComponent,
          }, {
            path: 'register/:id',
            component: RegisterSectorComponent,
          }
        ]
      },
      //Route Seller
      {
        path: 'seller',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SellerComponent
          },
          {
            path: 'register',
            component: RegisterSellerComponent,
          }, {
            path: 'register/:id',
            component: RegisterSellerComponent,
          }
        ]
      },
      //Route Service
      {
        path: 'service',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ServiceComponent,
          },
          {
            path: 'register',
            component: RegisterServiceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterServiceComponent,
          },
        ],
      },
      //Route Store
      {
        path: 'store',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StoreComponent,
          },
          {
            path: 'register',
            component: RegisterStoreComponent,
          },
          {
            path: 'register/:id',
            component: RegisterStoreComponent,
          },
        ],
      },
      //Route Subgroup
      {
        path: 'subgroup',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SubgroupComponent,
          },
          {
            path: 'register',
            component: RegisterSubgroupComponent,
          },
          {
            path: 'register/:id',
            component: RegisterSubgroupComponent,
          },
        ],
      },
      //Route Store Price
      {
        path: 'store-price',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: StorePriceComponent,
          },
        ],
      },
      //Route Subrental Cutoff
      {
        path: 'subrental-cutoff',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SubrentalCutoffComponent,
          },
          {
            path: 'register',
            component: RegisterSubrentalCutoffComponent,
          },
          {
            path: 'register/:id',
            component: RegisterSubrentalCutoffComponent,
          },
        ],
      },
      //Route Subrental Entry
      {
        path: 'subrental-entry',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SubrentalEntryComponent,
          },
          {
            path: 'register',
            component: RegisterSubrentalEntryComponent,
          },
          {
            path: 'register/:id',
            component: RegisterSubrentalEntryComponent,
          },
        ],
      },
      //Route Subrental Output
      {
        path: 'subrental-output',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SubrentalOutputComponent,
          },
          {
            path: 'register',
            component: RegisterSubrentalOutputComponent,
          },
          {
            path: 'register/:id',
            component: RegisterSubrentalOutputComponent,
          },
        ],
      },
      /////Routes Subrental Report -------------------
      // Route Item Utility
      {
        path: 'item-utility',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ItemUtilityComponent,
          },
        ],
      },
      // Route Item Preinvoiced Value
      {
        path: 'item-preinvoiced-value',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ItemPreinvoicedValueComponent,
          },
        ],
      },
      //Route Suspension
      {
        path: 'suspension',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SuspensionComponent
          },
          {
            path: 'register',
            component: RegisterSuspensionComponent
          },
          {
            path: 'register/:id',
            component: RegisterSuspensionComponent
          }
        ]
      },
      //Route Tax
      {
        path: 'tax',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TaxComponent
          },
          {
            path: 'register',
            component: RegisterTaxComponent
          },
          {
            path: 'register/:id',
            component: RegisterTaxComponent
          }
        ]
      },
      //Route Tax Type
      {
        path: 'tax-type',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TaxTypeComponent,
          }
        ],
      },
      //Route Transactions
      {
        path: 'transactions',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransactionsComponent,
          },
        ],
      },
      {
        path: 'transactions-by-company',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransactionsComponent,
          },
        ],
      },
      //Route Logs
      {
        path: 'logs',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: LogsComponent,
          },
        ],
      },
      //Route Transporter
      {
        path: 'transporter',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransporterComponent,
          },
          {
            path: 'register',
            component: RegisterTransporterComponent,
          },
          {
            path: 'register/:id',
            component: RegisterTransporterComponent,
          },
        ],
      },
      //Route TransportInvoice
      {
        path: 'transport-invoice',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TransportInvoiceComponent,
          },
          {
            path: 'register',
            component: RegisterTransportInvoiceComponent,
          },
          {
            path: 'register/:id',
            component: RegisterTransportInvoiceComponent,
          },
        ],
      },
      //Route Type Concept
      {
        path: 'type-concept',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TypeConceptComponent,
          }
        ],
      },
      //Route Type Inventory
      {
        path: 'type-inventory',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TypeInventoryComponent,
          }
        ],
      },
      //Route Siesa Synchronize
      {
        path: 'siesa-synchronize',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SynchronizeInventoryMovementComponent,
          }
        ],
      },
      //Route Unit
      {
        path: 'unit',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: UnitComponent,
          },
          {
            path: 'register',
            component: RegisterUnitComponent,
          },
          {
            path: 'register/:id',
            component: RegisterUnitComponent,
          },
        ],
      },
      //Route Unlock Process
      {
        path: 'unlock-process',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CloseConcurrenceComponent,
          },
        ],
      },
      //Route User
      {
        path: 'user',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: UserComponent,
          },
          {
            path: 'register',
            component: RegisterUsersComponent,
          },
          {
            path: 'register/:id',
            component: RegisterUsersComponent,
          },
        ],
      },
      //Route Vehicle
      {
        path: 'vehicle',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: VehicleComponent,
          },
          {
            path: 'register',
            component: RegisterVehicleComponent,
          },
          {
            path: 'register/:id',
            component: RegisterVehicleComponent,
          },
        ],
      },
      //Route WalletBalance
      {
        path: 'process-wallet-balance',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ProcessWalletBalanceComponent,
          },
        ],
      },
      //Route WalletManagement
      {
        path: 'wallet-management',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: WalletManagementComponent,
          },
          {
            path: 'register',
            component: RegisterWalletManagementComponent,
          },
          {
            path: 'register/:id',
            component: RegisterWalletManagementComponent,
          },
        ],
      },
      /////Routes Wallet Report -------------------
      //Route Collection By Seller
      {
        path: 'collection-by-seller',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: CollectionBySellerComponent,
          },
        ],
      },
      //Route Detailed Account Statement
      {
        path: 'detailed-account-statement',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: DetailedAccountStatementComponent,
          },
        ],
      },
      //Route Generated Receipts
      {
        path: 'generated-receipts',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: GeneratedReceiptsComponent,
          },
        ],
      },
      //Route Payments By Client
      {
        path: 'payments-by-client',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: PaymentsByClientComponent,
          },
        ],
      },
      //Route Summary Account Statement
      {
        path: 'summary-account-statement',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: SummaryAccountStatementComponent,
          },
        ],
      },
      //Route Total Income Per Month
      {
        path: 'total-income-per-month',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: TotalIncomePerMonthComponent,
          },
        ],
      },
      //Route Wallet
      {
        path: 'wallet',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: WalletComponent,
          },
        ],
      },
      //Route Wallet Balance
      {
        path: 'wallet-balance',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: WalletBalanceComponent,
          },
        ],
      },
      /////Routes Wallet Report ^^^^^^^^
      //Route WayToPay
      {
        path: 'way-to-pay',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: WayToPayComponent,
          },
          {
            path: 'register',
            component: RegisterWayToPayComponent,
          },
          {
            path: 'register/:id',
            component: RegisterWayToPayComponent,
          },
        ],
      },
      //Route Zone
      {
        path: 'zone',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: ZoneComponent,
          },
          {
            path: 'register',
            component: RegisterZoneComponent,
          },
          {
            path: 'register/:id',
            component: RegisterZoneComponent,
          },
        ],
      },
      {
        path: 'master-solution',
        canActivate: [CanActivateViewGuard],
        children: [
          {
            path: '',
            component: MasterSolutionComponent,
          },
          {
            path: 'register',
            component: RegisterMasterSolutionComponent,
          },
          {
            path: 'register/:id',
            component: RegisterMasterSolutionComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class ViewRoutingModule { }

